// src/features/rooms/pages/RoomDetailsPage/components/RoomDetailsCard.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Chip,
  Stack,
  Divider,
} from '@mui/material';
import {
  MeetingRoom as MeetingRoomIcon,
  SquareFoot as SquareFootIcon,
  Description as DescriptionIcon,
} from '@mui/icons-material';

const CLASSIFICATION_COLORS = {
  UNCLASSIFIED: 'default',
  SUPERVISED_AREA: 'warning',
  CONTROLLED_AREA: 'error',
};

export default function RoomDetailsCard({ room }) {
  const { t } = useTranslation('rooms');

  return (
    <Card sx={{ minWidth: "250px" }} >
      <CardContent>
        <Typography variant="h6" gutterBottom display="flex" alignItems="center" gap={1}>
          <MeetingRoomIcon color="primary" />
          {t('rooms:form.room_information')}
        </Typography>
        <Divider sx={{ my: 2 }} />

        <Stack spacing={2}>
          <Box>
            <Typography variant="caption" color="text.secondary">
              {t('rooms:labels.room_name')}
            </Typography>
            <Typography variant="body1" fontWeight="medium">
              {room.name}
            </Typography>
          </Box>

          <Box>
            <Typography variant="caption" color="text.secondary">
              {t('rooms:labels.classification')}
            </Typography>
            <Box mt={0.5}>
              <Chip
                label={t(`classifications.${room.classification}`)}
                size="small"
                color={CLASSIFICATION_COLORS[room.classification]}
                variant="outlined"
              />
            </Box>
          </Box>

          <Box>
            <Typography variant="caption" color="text.secondary" display="flex" alignItems="center" gap={0.5}>
              <SquareFootIcon fontSize="small" />
              {t('rooms:labels.area_m2')}
            </Typography>
            <Typography variant="body1" fontWeight="medium">
              {/* eslint-disable-next-line i18next/no-literal-string */}
              {room.area_m2} m²
            </Typography>
          </Box>

          {room.notes && (
            <Box>
              <Typography variant="caption" color="text.secondary" display="flex" alignItems="center" gap={0.5}>
                <DescriptionIcon fontSize="small" />
                {t('rooms:labels.notes')}
              </Typography>
              <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
                {room.notes}
              </Typography>
            </Box>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
}